import { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {

}

const IconPause = (props: Props) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="inherit"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x={2.29297}
      y={1.27539}
      width={4.33333}
      height={13}
      rx={2.16667}
      fill="inherit"
    />
    <rect
      x={9.51562}
      y={1.27539}
      width={4.33333}
      height={13}
      rx={2.16667}
      fill="inherit"
    />
  </svg>
);

export default IconPause;
